import { PrintStatus } from "common/api/decimal/methods/course";

// Not Returned: Opted out and has book
// Return Refused: Opted out and has book, damaged it
export const optedOutWithBook = (status: PrintStatus | undefined) =>
  status === "Not Returned" || status === "Return Refused";

// Do Not Issue: Opted out and never had the book
// Returned: Opted out and had book but completed a return
export const optedOutWithoutBook = (status: PrintStatus | undefined) =>
  status === "Do Not Issue" || status === "Returned";

export const isPickupDateInFuture = (
  pickupDate: string | null | undefined
): boolean => !!pickupDate && new Date(pickupDate) > new Date();
